// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-level {
  position: relative;
  margin: 10px;
  margin-left: 35px;
  margin-right: 35px;
  padding-bottom: 2px;
}
.top-level.inline-item {
  margin-left: 15px;
  margin-right: 15px;
}

.inline-item .card-element {
  display: inline-block;
}

.action-button {
  position: absolute;
  right: -5px;
  top: 0;
  z-index: 2;
}

.category {
  position: relative;
  display: inline-block;
  width: 100%;
}
.category .content {
  position: relative;
  display: block;
  height: 100%;
  padding: 5px;
  padding-right: 0;
  padding-left: 0;
}
.category .delete-button {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}

.folding-icon {
  cursor: pointer;
  vertical-align: -7px;
  margin-left: 6px;
}

.buttons {
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;
}

.content-text {
  margin: 10px;
  margin-bottom: 0;
  margin-top: 0;
  white-space: pre-wrap;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
  min-height: 29px;
  line-height: 27px;
}

.categories-container {
  padding-top: 5px;
  margin-top: 8px;
  border-top: 0.25px solid #dbdbdb;
  padding-left: 8px;
  padding-right: 8px;
}

.inline-item {
  min-width: 300px;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
}
.inline-item mat-card {
  width: 300px;
}

idea-item {
  margin-bottom: 14px;
  display: block;
}

.dragging {
  position: absolute;
  opacity: 0;
}

.category-placeholder {
  border: 2px dashed lightgray;
  border-radius: 4px;
  margin: 10px;
}

mat-card {
  padding: 3px;
}

.placeholder {
  border: 2px dashed lightgray;
  border-radius: 4px;
}
.placeholder.inline {
  display: inline-block;
  vertical-align: top;
  width: 300px;
  margin: 0;
}
.placeholder.before-placeholder {
  margin-bottom: 12px;
}
.placeholder.before-placeholder.inline {
  margin-bottom: 0;
  margin-right: 20px;
}
.placeholder.after-placeholder {
  margin-top: 12px;
}
.placeholder.after-placeholder.inline {
  margin-top: 0;
  margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/ideas-wall/core/category-item/category-item.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;AACJ;;AAIE;EACE,qBAAA;AADJ;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;AAHF;;AAMA;EACE,kBAAA;EAEA,qBAAA;EACA,WAAA;AAJF;AAME;EACE,kBAAA;EAEA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAYE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAVJ;;AAcA;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;AAXF;;AAcA;EAEE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AAZF;AAcE;EAEE,YAAA;AAbJ;;AAiBA;EACE,mBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,UAAA;AAdF;;AAiBA;EACE,4BAAA;EACA,kBAAA;EACA,YAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAkBA;EACE,4BAAA;EACA,kBAAA;AAfF;AAmBE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AAjBJ;AAoBE;EACE,mBAAA;AAlBJ;AAoBI;EACE,gBAAA;EACA,kBAAA;AAlBN;AAsBE;EACE,gBAAA;AApBJ;AAsBI;EACE,aAAA;EACA,iBAAA;AApBN","sourcesContent":[".top-level {\n  position: relative;\n  margin: 10px;\n  margin-left: 35px;\n  margin-right: 35px;\n  padding-bottom: 2px;\n\n  &.inline-item {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n}\n\n.inline-item {\n  .card-element {\n    display: inline-block;\n  }\n}\n\n\n.action-button {\n  position: absolute;\n  right: -5px;\n  top: 0;\n  z-index: 2;\n}\n\n.category {\n  position: relative;\n  // width: 150px;\n  display: inline-block;\n  width: 100%;\n\n  .content {\n    position: relative;\n    //background-color: #87cefa;\n    display: block;\n    height: 100%;\n    padding: 5px;\n    padding-right: 0;\n    padding-left: 0;\n\n    &.rolled {\n      //background-color: #f5f5f5;\n    }\n  }\n\n  .delete-button {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    cursor: pointer;\n  }\n}\n\n.folding-icon {\n  cursor: pointer;\n  vertical-align: -7px;\n  margin-left: 6px;\n}\n\n.buttons {\n  position: absolute;\n  right: 0;\n  top: 5px;\n  cursor: pointer;\n}\n\n.content-text {\n  //font-family: \"nexabold\";\n  margin: 10px;\n  margin-bottom: 0;\n  margin-top: 0;\n  white-space: pre-wrap;\n  text-align: left;\n  font-size: 13px;\n  font-weight: bold;\n  min-height: 29px;\n  line-height: 27px;\n}\n\n.categories-container {\n  padding-top: 5px;\n  margin-top: 8px;\n  border-top: 0.25px solid #dbdbdb;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.inline-item {\n  min-width: 300px;\n  display: inline-block;\n  vertical-align: top;\n  white-space: nowrap;\n\n  mat-card {\n    //display: inline-block;\n    width: 300px;\n  }\n}\n\nidea-item {\n  margin-bottom: 14px;\n  display: block;\n}\n\n.dragging {\n  position: absolute;\n  opacity: 0;\n}\n\n.category-placeholder {\n  border: 2px dashed lightgray;\n  border-radius: 4px;\n  margin: 10px;\n}\n\nmat-card {\n  padding: 3px;\n  //font-family: \"nexa\";\n}\n\n.placeholder {\n  border: 2px dashed lightgray;\n  border-radius: 4px;\n  //margin-right: 35px;\n  //margin-left: 35px;\n\n  &.inline {\n    display: inline-block;\n    vertical-align: top;\n    width: 300px;\n    margin: 0;\n  }\n\n  &.before-placeholder {\n    margin-bottom: 12px;\n\n    &.inline {\n      margin-bottom: 0;\n      margin-right: 20px;\n    }\n  }\n\n  &.after-placeholder {\n    margin-top: 12px;\n\n    &.inline {\n      margin-top: 0;\n      margin-left: 20px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
